

import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    ActivatedRoute
} from '@angular/router';

import { RequestdollhouseService } from './requestdollhouse.service';

@Injectable()
export class RequestdollhouseGuard implements CanActivate {
    constructor(private router: Router, private requestdollhouseService: RequestdollhouseService, private activatedRoute: ActivatedRoute) {
      this.activatedRoute.params.subscribe( params => console.log(params) );
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        const path: string = route.routeConfig.path;
        return this.verifyWorkFlow(path, state.url);
    }

    verifyWorkFlow(path, routerUrl): boolean {
        // // If any of the previous steps is invalid, go back to the first invalid step
        const firstPath = this.requestdollhouseService.getFirstInvalidStep(path);
        if (firstPath.length > 0) {
            console.log('Redirected to ' + firstPath + ' path which it is the first invalid step.');
            let url = routerUrl;
            url = url.replace('card', '');
            this.router.navigate([url]);
            return false;
        }
        return true;
    }
}
